__turbopack_context__.v({
  "burgerContainer": "VrYR0q_burgerContainer",
});
